import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
// --- img ----------------------------------------------------------------
import { logoImg, snsIconInsta, snsIconNaver, snsIconThreads, snsIconTiktok, snsIconYoutube } from "../../assets/images";
// --- style ----------------------------------------------------------------
import "./Header.scss";

function Header() {
  const { pathname } = useLocation();
  // --- 상태----------------------------------------------------------------
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePathScroll = (to) => (e) => {
    if (pathname === to) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // --- 핸들러----------------------------------------------------------------
  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header__inner">
        {/* === 로고 영역 === */}
        <div className="header__logo">
          {/* --- 모바일 햄버거 --- */}
          <button
            type="button"
            className={`hamburger ${isMenuOpen ? "is-open" : ""}`}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen} // a11y. 메뉴 확장 상태 전달
            aria-controls="mobile-menu" // a11y. 제어 대상(menu) id 연결
            onClick={handleToggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* --- 로고 --- */}
          <h1>
            <Link to="/" onClick={handlePathScroll("/")}>
              <img src={logoImg} alt="MOB Studio Logo" />
            </Link>
          </h1>
        </div>

        {/* === GNB 영역 === */}
        <nav className="header__gnb" aria-label="Main Menu">
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={handlePathScroll("/")}
                className={({ isActive }) => `${isActive ? "active" : ""}`}
              >
                <span className="gnb-label">About</span>
                <span className="gnb-sub">회사소개</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/service"
                onClick={handlePathScroll("/service")}
                className={({ isActive }) => `${isActive ? "active" : ""}`}
              >
                <span className="gnb-label">Service</span>
                <span className="gnb-sub">서비스</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/music"
                onClick={handlePathScroll("/music")}
                className={({ isActive }) => `${isActive ? "active" : ""}`}
              >
                <span className="gnb-label">Music</span>
                <span className="gnb-sub">음악</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/portfolio"
                onClick={handlePathScroll("/portfolio")}
                className={({ isActive }) => `${isActive ? "active" : ""}`}
              >
                <span className="gnb-label">Portfolio</span>
                <span className="gnb-sub">포트폴리오</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/recruit"
                onClick={handlePathScroll("/recruit")}
                className={({ isActive }) => `${isActive ? "active" : ""}`}
              >
                <span className="gnb-label">Recruit</span>
                <span className="gnb-sub">채용 안내</span>
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* === 소셜 영역 === */}
        <ul className="header__social" aria-label="MOB Studio social network list">
          <li>
            <a href="https://www.instagram.com/mob_studio__/" target="_blank" rel="noopener noreferrer" aria-label="MOB Studio Instagram">
              <img src={snsIconInsta} alt="" aria-hidden="true" />
            </a>
          </li>
          <li>
            <a href="https://www.threads.com/@mob_studio__" target="_blank" rel="noopener noreferrer" aria-label="MOB Studio Threads">
              <img src={snsIconThreads} alt="" aria-hidden="true" />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@mob_studio_0" target="_blank" rel="noopener noreferrer" aria-label="MOB Studio Youtube channel">
              <img src={snsIconYoutube} alt="" aria-hidden="true" />
            </a>
          </li>                             
          <li>
            <a href="https://www.tiktok.com/@mob_studio__" target="_blank" rel="noopener noreferrer" aria-label="MOB Studio TikTok channel">
              <img src={snsIconTiktok} alt="" aria-hidden="true" />
            </a>
          </li>
          <li>
            <a href="https://blog.naver.com/musicontheblock_kr" target="_blank" rel="noopener noreferrer" aria-label="MOB Studio Naver Blog">
              <img src={snsIconNaver} alt="" aria-hidden="true" />
            </a>
          </li>                
        </ul>
      </div>

      {/* === 모바일용 FNB 영역 === */}
      <div
        id="mobile-menu"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-menu-title"
        className={isMenuOpen ? "is-open" : ""}
      >
        <h2 id="mobile-menu-title">Menu</h2>
        <nav aria-label="Mobile main navigation">
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={closeMobileMenu}
              >
                <strong>About</strong>
                <span>회사소개</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/service" onClick={closeMobileMenu}>
                <strong>Service</strong>
                <span>서비스</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/music" onClick={closeMobileMenu}>
                <strong>Music</strong>
                <span>음악</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/portfolio" onClick={closeMobileMenu}>
                <strong>Portfolio</strong>
                <span>포트폴리오</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/recruit" onClick={closeMobileMenu}>
                <strong>Recruit</strong>
                <span>채용 안내</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
